<div class="modal-content">
  <apm-section-title title="{{ 445128 | apmTranslate }}"></apm-section-title>

  @if (projectSelections().length) {
    <div class="d-block quote-selection-height">
      @for (q of projectSelections(); track q.details.uuid) {
        <div
          class="w-100 shadow hover-shadow cursor-pointer mt-2 text-md py-4 ps-3 position-relative"
          (click)="quoteSelected(q)"
        >
          @if (selectedSelection()?.details?.uuid === q.details.uuid) {
            <div class="selected"></div>
          }
          <span>{{ q?.details?.title }}</span>
        </div>
      }
    </div>
  } @else {
    <div class="apm-card w-100 px-2 py-4 shadow cursor-pointer mt-2 text-md">
      <span>{{ '445224' | apmTranslate }}</span>
    </div>
  }
  <div class="d-flex float-end mt-3">
    <apm-button class="ms-1" [disabled]="!this.selectedSelection()" (click)="this.selectedSelection() ? save() : null">
      {{ '444682' | apmTranslate }}
    </apm-button>
  </div>
</div>
